import { render, staticRenderFns } from "./kins_details.vue?vue&type=template&id=95b32526"
import script from "./kins_details.vue?vue&type=script&lang=js"
export * from "./kins_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports